<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.searchKey"
              :placeholder="
                $l('from_label_detailen_organization') ||
                  '机构编码/机构名称搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="$emit('openEditFormDialog', { type: 'add' })"
              v-if="allow('A')"
            >
              <!-- <b-icon-plus></b-icon-plus> -->
              {{ $l('INDEX.btn_add') || '新增' }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="700px"
      :close-on-click-modal="false"
      v-el-dialog-drag
    >
      <el-form ref="form" :model="form" size="small">
        <el-row :gutter="20">
          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item
              :label="$l('form_label_organization_code') || '机构编码'"
            >
              <el-input
                v-model.trim="form.orgNo"
                :placeholder="
                  $l('form_label_please_organization_code') || '请输入机构编码'
                "
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item
              :label="$l('form_label_organization_name') || '机构名称'"
            >
              <el-input
                v-model.trim="form.orgName"
                :placeholder="
                  $l('form_label_pleaseEnter_organization_name') ||
                    '请输入机构名称'
                "
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <!-- <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }"> -->
          <el-form-item
            :label="$l('form_label_Provinces_cities_counties') || '省市区县'"
          >
            <region-cascader
              show
              :props="{ multiple: true, checkStrictly: true }"
              multiple
              size="small"
              @multipleChange="multipleChange"
              ref="regionCascader"
            />
          </el-form-item>
          <!-- </el-col> -->
          <!-- <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item
              :label="$l('form_label_detailed_address') || '详细地址'"
            >
              <el-input
                clearable
                v-model="form.orgAddress"
                :placeholder="$l('form_label_detailed_address') || '详细地址'"
              >
              </el-input>
            </el-form-item>
          </el-col> -->
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_valid_status') || '有效状态'">
              <el-checkbox-group v-model="form.orgStatusList">
                <el-checkbox label="Y">{{
                  $l('from_radio_effective') || '有效'
                }}</el-checkbox>
                <el-checkbox label="N">{{
                  $l('form_label_invalid') || '无效'
                }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">{{
          $l('INDEX.btn_cancel_query') || '取消查询'
        }}</el-button>
        <el-button size="small" type="warning" @click="reset">{{
          $l('INDEX.btn_reset_filter') || '重置条件'
        }}</el-button>
        <el-button size="small" type="primary" @click="advquery">{{
          $l('INDEX.btn_data_retrieval') || '数据检索'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  searchKey: '',
  orgStatusList: ['Y']
}

export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
      regionParams: {}
    }
  },
  created() {
    this.query()
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', { ...this.form, ...this.regionParams })
    },
    // 高级查询
    advquery() {
      this.form.searchKey = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
      this.$refs.regionCascader.clearValue()
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    multipleChange(val) {
      this.regionParams = { ...val }
    }
  }
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
